<template>
	<span :title="model">
		<v-checkbox
			:hint="hint"
			:label="label"
			:disabled="inputDisabled"
			v-model="privateModel"
			@click.stop="clickedOn"
			:color="this.model === false ? 'error' : 'accent'"
			persistent-hint
			:rules="computedRules"
		>
		</v-checkbox>

		<!-- @change="update" -->
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	data() {
		return {
			privateModel: null,
		}
	},
	methods: {
		clickedOn() {
			if (this.model === null) {
				this.model = true
				this.privateModel = true
			} else if (this.model === true) {
				this.model = false
			} else {
				this.model = null
				this.privateModel = false
			}
			this.update()
		},
	},
}
</script>
<style lang="scss">
.searchFalse {
	.accent--text {
		color: red;
	}
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/inputs/checkboxWithNullInput.vue